module.exports = __webpack_public_path__ + "static/img/gb-right.016b76b9.jpg";